<template>
    <div class="content">
        <h2 style="word-break: break-word;">
            IMPORTANT REMINDERS:
        </h2>
        <ol>
            <li>
                All medical services described herein are covered and may be subject to
                limitations, so long as they are DIRECTED and AUTHORIZED by an HMI PIC
                (Physician In-Charge) and available within the HMI affiliated medical
                network, unless otherwise excluded.
            </li>
            <li>
                All Hospital/Clinic/MSU charges that are NOT coverable by HMI must be
                paid by the member upon discharge. Any outstanding or unpaid obligations
                will lead to the lapsation of your membership and prevent you from
                availing of the healthcare benefits of your HMI Program.
            </li>

            <li>
                To know more about your benefits, kindly refer to your HMI Service
                Agreement
            </li>
        </ol>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.content {
  width: 70%;
  margin: auto;
  padding: 10px;
}
.content h2 {
  font-size: 30px;
  text-align: justify;
  color: #1b5e20;
}
.content ol li {
  font-size: 16px;
  color: black;
  margin-top: 15px;
  text-align: justify;
}
@media (max-width: 968px) {
  .content {
    width: 100%;
  }
  .content h2 {
    font-size: 25px;
    text-align: center;
  }
}
</style>
